module.exports = __webpack_public_path__ + "img/IMG_2614_T_L_Black_MockedUp.664c6740.jpg";